import { SearchOption } from "./search-option";

export class DbStorageFileDetectionSettingsInfos {
  scanningIntervalInMs: number | null = 5000;
  growingFileSleepingIntervalInMs: number | null = 5000;
  growingFileCheckerLoopingNumber: number | null = 2;
  threadSize: number | null = 5;
  searchOption: SearchOption | null = null;
  fileExtensions: string[] | null = null;

  constructor(init?: Partial<DbStorageFileDetectionSettingsInfos>) {
    Object.assign(this, init);
  }
}
